import React from 'react';
import {Link} from 'react-router-dom';
import cx from 'classnames';

import Jumbotron from 'ui/Jumbotron/Jumbotron';
import Navbar from 'ui/Navbar/Navbar';
import {useWaypoints} from 'ui/Navbar/useWaypoints';
import Raw from 'ui/Raw/Raw';
import Social from 'ui/Social/Social';
import AlgoliaSearch from 'ui/AlgoliaSearch/AlgoliaSearch';

import President from './President';
import Culture from './Culture';
import Perks from './Perks';
import Teams from './Teams';
import Location from './Location';

import './WelcomePage.less';

const WelcomeJumbotron = ({
    title,
    bgImageUrl,
    body,
    callToActionText,
    callToActionUrl,
    algolia,
    history,
}) => (
    <section id="careers-overview">
        <Jumbotron backgroundImage={bgImageUrl} title={title}>
            <div className="text-constrained">
                <Raw content={body} className="text-white" />
                <AlgoliaSearch {...algolia} history={history} />
                <Link
                    to={callToActionUrl}
                    className="btn btn-default btn-sm btn-inverse"
                >
                    {callToActionText}
                </Link>
            </div>
        </Jumbotron>
    </section>
);

const WelcomePage = ({data, history}) => {
    const {
        content: {sections},
        translations,
        algolia,
    } = data;

    const {links, waypoints, active, visible, buttonWaypoint} = useWaypoints({
        sections: sections[0].items,
        withBack: false,
        withButton: true,
    });

    const cultureData = {
        leading: translations['careers.culture.subtitle'],
        items: [
            'scientificMindset',
            'openness',
            'oneTeam',
            'participation',
            'mastery',
        ].map((item) => {
            return {
                title: translations[`careers.culture.core.${item}.title`],
                body: translations[`careers.culture.core.${item}.body`],
                name: item,
            };
        }),
    };

    return (
        <div className="container-welcome">
            <Navbar
                links={links}
                active={active}
                button={
                    <Link
                        to={sections[1].callToActionUrl}
                        className={cx(
                            'btn btn-primary btn-sm',
                            visible && 'btn-visible',
                        )}
                    >
                        {sections[1].callToActionText}
                    </Link>
                }
            />
            {waypoints[0]}
            <WelcomeJumbotron
                {...sections[1]}
                algolia={algolia}
                history={history}
            />
            {buttonWaypoint}
            <President {...sections[2]} />
            {waypoints[1]}
            <Culture {...sections[3]} {...cultureData} />
            <Perks {...sections[4]} />
            {waypoints[2]}
            <Teams {...sections[5]} />
            {waypoints[3]}
            <Location {...sections[7]} />
            <Social {...sections[8]} />
        </div>
    );
};

export default WelcomePage;
